import { loaderStart, loaderFinish } from './loader';
import { toastError, toastSuccess } from '../utils/toastMessage';
import { getComplexes, setFoodCorseSelectedComplex } from './complex';
import errorHandler from '../utils/errorHandler';
import * as constants from '../constants/constants';
import { setMenuMenuGenerator, transformMenuStructure, countDishValues } from './menu';
import {
  getDefaultMenu,
  DEFAULT_HEIGHT_GENERATION,
  DEFAULT_WEIGHT_GENERATION,
  DEFAULT_AGE_GENERATION,
  DEFAULT_GENDER_GENERATION,
  DEFAULT_GOAL_GENERATION,
  DEFAULT_ACTIVITY_GENERATION,
} from '../constants/appConstants';
import API from '../utils/API';
import generateUniqueId from '../utils/generateUniqueId';

const STATUS_ID_COMPLEX_TO_PUBLISH = 2;

const mealTypesDictionary = {
  morning: {
    title: 'Утро',
    order: 0,
    time: null,
  },
  breakfast: {
    title: 'Завтрак',
    order: 1,
    time: '+ 20 мин',
  },
  breakfastSnack: {
    title: 'Перекус',
    order: 2,
    time: '+ 1,5 часа',
  },
  lunch: {
    title: 'Обед',
    order: 3,
    time: '+ 1,5 часа',
  },
  lunchSnack: {
    title: 'Второй перекус',
    order: 4,
    time: '+ 2 часа',
  },
  dinner: {
    title: 'Ужин',
    order: 5,
    time: '+ 2 часа',
  },
  dinnerSnack: {
    title: 'Вечерний перекус',
    order: 6,
    time: 'За 2 часа до сна',
  },
};

export const clearAfterGetPDF = () => {
  return {
    type: 'CLEAR_AFTER_GET_PDF',
  };
};

export const getPDFSuccess = (link) => {
  return {
    type: 'GET_PDF_SUCCESS',
    payload: { link },
  };
};

export const getPDFError = (data) => {
  return {
    type: 'GET_PDF_ERROR',
    data,
  };
};

export const toggleIsShowConfirmPublishComplex = () => {
  return {
    type: constants.TOGGLE_IS_SHOW_CONFIRM_PUBLISH_COMPLEX,
  };
};

export const generateMenuSuccess = () => {
  return {
    type: 'GENERATE_MENU_SUCCESS',
  };
};

const transformGeneratedMealsData = (dayDishesInfo) => {
  const newMealsData = [];
  for (const mealName in dayDishesInfo) {
    if (!mealTypesDictionary[mealName]) continue;
    dayDishesInfo[mealName].forEach((dishData) => {
      if (!dishData.id) dishData.id = generateUniqueId();
      if (!dishData.time) {
        dishData.time = mealTypesDictionary[mealName].time;
        if (dishData.dish.name === 'Вода') {
          dishData.time = '+ час';
          if (mealName === 'morning') dishData.time = 'Натощак';
        }
      }
      countDishValues(dishData, 'calories');
      countDishValues(dishData, 'proteins');
      countDishValues(dishData, 'fats');
      countDishValues(dishData, 'carbohydrates');
    });

    newMealsData.push({
      type: mealName,
      title: mealTypesDictionary[mealName].title,
      order: mealTypesDictionary[mealName].order,
      meals: dayDishesInfo[mealName],
    });
  }
  const newSortedMealsData = newMealsData.sort((current, prev) => {
    if (current.order > prev.order) {
      return 1;
    }
    if (current.order < prev.order) {
      return -1;
    }
    return 0;
  });

  return newSortedMealsData;
};

export const transformGeneratedMenuStructure = (menu) => {
  return menu.map((dayDishesInfo) => transformGeneratedMealsData(dayDishesInfo));
};

const generateMenuWaiting = function (complexId, generateMenuInterval) {
  return (dispatch, getState) => {
    API.get(`/complexes/${complexId}/food-course`)
      .then((result) => {
        const currentMenu = JSON.stringify(getState().menu.menu);
        const numberOfRecurringDays = getState().menu.sameDaysCount;
        const transformForCheck = transformGeneratedMenuStructure(result.data.data.menu);
        const generatedMenu = JSON.stringify(transformForCheck);
        if (generatedMenu !== currentMenu) {
          toastSuccess('Меню успешно сгенерировано');
          const transformedMenuGeneratedMenu = transformMenuStructure(
            result.data.data.menu,
            numberOfRecurringDays,
          );
          dispatch(setMenuMenuGenerator(transformedMenuGeneratedMenu));
          clearInterval(generateMenuInterval);
          dispatch(generateMenuSuccess());
          dispatch(loaderFinish());
        }
      })
      .catch(function (error) {
        if (error.response.status === 404) {
          return;
        }
        const errorConfig = {
          500: {
            type: 'error',
            message: 'Внутренняя ошибка сервера',
          },
        };
        errorHandler(error.response.status, errorConfig);
      });
  };
};

export const generateMenu = (
  excludeTagsArr,
  days,
  duplicateDays,
  complex_id,
  chosenEatings = [],
  user = null,
) => {
  return (dispatch) => {
    const excludeTags = excludeTagsArr.join('|');
    const eatingsTags = chosenEatings.join('|');
    let height = DEFAULT_HEIGHT_GENERATION;
    let weight = DEFAULT_WEIGHT_GENERATION;
    let age = DEFAULT_AGE_GENERATION;
    let gender = DEFAULT_GENDER_GENERATION;
    let goal = DEFAULT_GOAL_GENERATION;
    let activity = DEFAULT_ACTIVITY_GENERATION;
    if (user && user.id) {
      height = user.params.height;
      weight = user.params.weight;
      age = user.params.age;
      gender = user.params.gender_id;
      goal = user.goals.weight;
      activity = user.params.activity.coefficient;
    }
    if (!eatingsTags.length) {
      toastError('Приемы пищи не выбраны.');
      return;
    }
    dispatch(loaderStart());
    API.get('/menus/get', {
      params: {
        days,
        numberOfRecurringDays: duplicateDays,
        complex_id,
        exclude_tags: excludeTags,
        eating_tags: eatingsTags,
        height,
        weight,
        age,
        gender,
        goal,
        activity,
      },
    })
      .then(() => {
        const generateMenuInterval = setInterval(
          () => dispatch(generateMenuWaiting(complex_id, generateMenuInterval)),
          15000,
        );
      })
      .catch((error) => {
        dispatch(setMenuMenuGenerator(getDefaultMenu()));
        dispatch(loaderFinish());
        const errorConfig = {
          400: {
            message: 'Сгенерировать меню не удалось',
          },
        };
        errorHandler(error.response.status, errorConfig);
      });
  };
};

export const transformMenuForSave = (menu) => {
  const transformedMenu = {};
  menu.forEach((menuForDay, i) => {
    if (!transformedMenu[`item${i}`]) transformedMenu[`item${i}`] = {};
    menuForDay.forEach((eating) => {
      if (!transformedMenu[`item${i}`][eating.type]) transformedMenu[`item${i}`][eating.type] = {};
      let dishIndex = 0;
      eating.meals.forEach((dishData) => {
        const dishForSend = dishData.dish;
        if (dishForSend.name) {
          // delete empty dish rows
          dishForSend.quantity = dishData.quantity;
          dishForSend.weight = dishData.quantity; // TODO: why this parameter should send for save?
          dishForSend.mealtime = dishData.time;
          transformedMenu[`item${i}`][eating.type][dishIndex] = dishForSend;
          dishIndex++;
        }
      });
    });
  });
  return transformedMenu;
};

export const clearPdfLink = () => {
  return {
    type: 'CLEAR_PDF_LINK',
  };
};

export const saveMenu = (menu, user, complexId, dayCount, category, eatingTags) => {
  return (dispatch, getState) => {
    dispatch(loaderStart());
    const transformedMenuForSave = transformMenuForSave(menu);
    const filters = [...eatingTags, ...category];
    const recurringDayCount = getState().menu.sameDaysCount;
    API.post('/menus', {
      dishes: transformedMenuForSave,
      user: user,
      days: dayCount,
      filters,
      complexId,
      numberOfRecurringDays: recurringDayCount,
    })
      .then((resp) => {
        if (resp.data.data.complex_menu_id) {
          dispatch(setFoodCorseSelectedComplex(resp.data.data.complex_menu_id));
        }
        toastSuccess();
        dispatch(clearPdfLink());
        dispatch(loaderFinish());
      })
      .catch(() => {
        dispatch(loaderFinish());
        toastError();
      });
  };
};

export const getPDF = (foodCourseId) => {
  return (dispatch) => {
    dispatch(loaderStart());
    dispatch(clearAfterGetPDF());
    API.get(`/menus/generate/${foodCourseId}`)
      .then((response) => {
        dispatch(getPDFSuccess(response.data.data.link));
        dispatch(loaderFinish());
        toastSuccess();
      })
      .catch(function (error) {
        dispatch(getPDFError(error));
        dispatch(loaderFinish());
        toastError();
      });
  };
};

export const publishSelectedComplex = (complexId) => {
  return (dispatch, getState) => {
    dispatch(loaderStart());
    API.post(`/complexes/change-status/${complexId}`, {
      status: STATUS_ID_COMPLEX_TO_PUBLISH,
    })
      .then(() => {
        const { user } = getState().reducers;
        dispatch(loaderFinish());
        dispatch(getComplexes(user.id));
        dispatch(toggleIsShowConfirmPublishComplex());
      })
      .catch((error) => {
        dispatch(loaderFinish());
        if (error.request && error.request && error.request.status === (400 || 422)) {
          toastError('У данного пользователя уже есть активный курс');
        } else toastError();
      });
  };
};

export const updateSelectedComplexType = (complexId, is_individual) => {
  return (dispatch, getState) => {
    dispatch(loaderStart());
    API.post(`/complexes/${complexId}/edit`, {
      is_individual,
    })
      .then(() => {
        const { user } = getState().reducers;
        dispatch(loaderFinish());
        dispatch(getComplexes(user.id));
      })
      .catch(() => {
        toastError();
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/menuActions.js